module.exports = __webpack_public_path__ + "img/alarmBackLight.7326c076.png";